(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collarva-motion"] && !Shopify.designMode) return;
  try {
    
(()=>{const reduced=matchMedia('(prefers-reduced-motion: reduce)');function mount(root){root.querySelectorAll('[data-cv-motion]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const video=section.querySelector('video');if(!video)return;const button=section.querySelector('[data-cv-toggle]');if(button){const label=()=>{button.textContent=video.paused?button.dataset.play:button.dataset.pause};video.addEventListener('play',label);video.addEventListener('pause',label);button.addEventListener('click',()=>{video.dataset.userPaused=String(!video.paused);video.paused?video.play().catch(label):video.pause()})}const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)video.pause();else if(video.hasAttribute('data-decorative')&&!reduced.matches&&video.dataset.userPaused!=='true')video.play().catch(()=>{})}),{threshold:.2});observer.observe(video)})}mount(document);document.addEventListener('shopify:section:load',e=>mount(e.target));document.addEventListener('visibilitychange',()=>{if(document.hidden)document.querySelectorAll('[data-cv-motion] video').forEach(v=>v.pause())})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
